export default __webpack_public_path__ + "static/media/character_thumbail3.813a49d6.png";